import React from 'react';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import HomeIcon from '@mui/icons-material/Home';
import WorkIcon from '@mui/icons-material/Work';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

const BreadcrumbContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(1, 4),
}));

const StyledLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  textDecoration: 'none',
  color: '#667eea',
  fontSize: '0.875rem',
  fontWeight: 500,
  transition: theme.transitions.create(['color'], {
    duration: theme.transitions.duration.short,
  }),
  '&:hover': {
    color: theme.palette.primary.alt,
    textDecoration: 'none',
  },
}));

const CurrentPageText = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  fontSize: '0.875rem',
  fontWeight: 600,
  color: '#667eea',
}));

const getIconForPath = (path, label) => {
  if (path === '/' || label === 'Home') {
    return <HomeIcon fontSize="small" />;
  }
  if (path.includes('Collections') || label === 'Collections') {
    return <WorkIcon fontSize="small" />;
  }
  if (path.includes('drives') || label === 'Drives') {
    return <DirectionsCarIcon fontSize="small" />;
  }
  return null;
};

const Breadcrumbs = ({ items }) => {
  return (
    <BreadcrumbContainer>
      <MuiBreadcrumbs
        aria-label="breadcrumb"
        separator={<NavigateNextIcon fontSize="small" sx={{ color: 'text.disabled' }} />}
        sx={{
          '& .MuiBreadcrumbs-separator': {
            marginLeft: 1,
            marginRight: 1,
          },
        }}
      >
        {items.map((item, index) =>
          index === items.length - 1 ? (
            <CurrentPageText key={item.path}>
              {getIconForPath(item.path, item.label)}
              {item.label}
            </CurrentPageText>
          ) : (
            <StyledLink key={item.path} component={RouterLink} to={item.path}>
              {getIconForPath(item.path, item.label)}
              {item.label}
            </StyledLink>
          )
        )}
      </MuiBreadcrumbs>
    </BreadcrumbContainer>
  );
};

export default Breadcrumbs;

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ).isRequired,
};
